import { Component, OnInit, Input, Output, EventEmitter, ViewContainerRef } from '@angular/core';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { environment } from 'environments/environment';
import { TranslateService } from '@ngx-translate/core';
import {
  ValidationUtilService,
  ApiRequestService,
  LookupDataService,
  CommonUtilty,
  I18nService,
  MultiLingualService,
  AppMetadataHandler
} from 'app'
import { AbstractControl, FormBuilder, FormControl, FormGroup, FormArray, Validators } from '@angular/forms';
import * as moment from 'moment/moment';

@Component({
  selector: 'app-police-details',
  templateUrl: './police-details.component.html',
  styleUrls: ['./police-details.component.scss']
})
export class PoliceDetailsComponent implements OnInit {

  constructor(private viewContainerRef: ViewContainerRef,
    private validationUtilService: ValidationUtilService,
    private apiRequestService: ApiRequestService,
    private fb: FormBuilder,
    private commonUtilty: CommonUtilty,
    private i18nService: I18nService,
    private multiLingualService: MultiLingualService,
    private translateService: TranslateService,
    private lookupDataService: LookupDataService,
    public appMetadataHandler: AppMetadataHandler) { }

    //Declaraions which might need developer input
    policeDetailsForm: FormGroup
    POLICEDETAILSFORMNAME = "policeDetailsForm"
    lookupsToBind = ['clmEventTypeCd', 'clmCauseOfDeathCd']
  
    /**
     * ComponentSpecific Inputs, Outputs and Functions
     *  
     */
    @Output() componentOutput = new EventEmitter<any>();
    @Input() type: string;

    hasPoliceStnDetails
    
    EmitComponentOutput(data) {
      this.componentOutput.emit(data)
    }
    getParentComponent(): Component {
      try{ return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component
 } catch{}
    }
    getParentComponentName(): Component {
      try{ return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component.constructor.name
 } catch{}
    }
  
    //Initializations
    lookup$ = this.commonUtilty.initializeLookupList(this.lookupsToBind)
  
    ngOnInit() {
      var consoleStyle = 'color: red; padding: 2px 5px; border-radius: 2px'
      if (environment && !environment.production) {
        console.group('%cPolice Details : Usage detected on ' + this.getParentComponentName(), 'color: white; background-color: orange; padding: 2px 5px; border-radius: 2px');
        console.log("%c<app-police-details></app-police-details>, has been used. ", consoleStyle)
        console.log("%cYou can override default title, message and icon(ng-zorro icon name).", consoleStyle)
        console.log("%cExample , <app-police-details (componentOutput)='doSomethingOnDataReceived()'></app-police-details>", consoleStyle)
        console.groupEnd();
      }
      this.initializeClientSearchForm()
    }
  
    /**
     * Form Trasactions
     */
  
    initializeClientSearchForm() {
      this.policeDetailsForm = this.fb.group({
        FIRNumber: this.validationUtilService.setValidationsForFormControl('FIRNumber', this.POLICEDETAILSFORMNAME),
        FIRDate: this.validationUtilService.setValidationsForFormControl('FIRDate', this.POLICEDETAILSFORMNAME),
        Address: this.validationUtilService.setValidationsForFormControl('Address', this.POLICEDETAILSFORMNAME),
        Remarks: this.validationUtilService.setValidationsForFormControl('Remarks', this.POLICEDETAILSFORMNAME)
  
      });
    }

}
